import { render, staticRenderFns } from "./PreviewInstructionsSection.vue?vue&type=template&id=76cf8b55&scoped=true&"
import script from "./PreviewInstructionsSection.vue?vue&type=script&lang=js&"
export * from "./PreviewInstructionsSection.vue?vue&type=script&lang=js&"
import style0 from "./PreviewInstructionsSection.vue?vue&type=style&index=0&id=76cf8b55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cf8b55",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
